import { createContext, useContext, useState, useEffect } from "react";
import BryntumContext, { userPreferences } from "./bryntumContext.jsx";
import { StringHelper } from "@bryntum/schedulerpro";
import { PERSISTENCE_STATE_KEYS } from "../../other/constants/PersistenceStateKeys.jsx";
import { STORE_KEYS } from "@/other/constants/StoreKeys.jsx";
import { useSwivuStore } from "../hooks/useSwivuStore";
import useViews from "@/react/hooks/useViews.jsx";

const RecentViewsContext = createContext(null);

export const RecentViewsProvider = ({ children }) => {
  const { project } = useContext(BryntumContext);
  const [currentViews, setCurrentViews] = useState([]);
  const { version } = useSwivuStore({ storeId: STORE_KEYS.userPreferencesStore, subscriberFn: ({record: changedRecord}) => changedRecord?.key === PERSISTENCE_STATE_KEYS.lastVisitedViews });
  const viewManagerState = useViews();

  useEffect(() => {
    if (project && userPreferences) {
      const currentHistory = userPreferences.getSetting(PERSISTENCE_STATE_KEYS.lastVisitedViews, "{}");
      const viewIds = Object.values(StringHelper.safeJsonParse(currentHistory));

      // Note: do not get views from the useViewsMenu as when saving a custom view the useViewsMenu may not have been updated
      const newViewIds = viewIds
        .map((viewId) => project.viewsStore.getById((viewId)))
        .filter(Boolean)
        .filter((view) => !view.isHidden);

      const currentIds = currentViews.map((v) => v.id);
      const newIds = newViewIds.map((v) => v.id);

      if (JSON.stringify(newIds) !== JSON.stringify(currentIds)) {
        setCurrentViews(newViewIds);
      }
    }
  }, [project, userPreferences, version, viewManagerState?.selectedView]);

  return (
    <RecentViewsContext.Provider value={{ currentViews }}>
      {children}
    </RecentViewsContext.Provider>
  );
};

export const useRecentViews = () => {
  const context = useContext(RecentViewsContext);
  if (!context) {
    throw new Error("useViewTransition must be used within ViewTransitionProvider");
  }
  return context;
};

export default RecentViewsContext;
